import { axios } from "common/helpers"

export function get() {
    return axios.get("/api/companies")
}

export function update(company) {
    const { users = [], catalogs = [], ...rest } = company
    const userIds = users.map(user => user.id)
    const catalogIds = catalogs.map(catalog => catalog.id)

    if (!rest.userLicenses) {
        rest.userLicenses = 0
    }

    if (!rest.catalogLicenses) {
        rest.catalogLicenses = 0
    }

    return axios.patch(`/api/companies/${company.id}`, {
        users: userIds,
        catalogs: catalogIds,
        ...rest
    })
}

export function create(company) {
    const { users = [], catalogs = [], ...rest } = company
    const userIds = users.map(user => user.id)
    const catalogIds = catalogs.map(catalog => catalog.id)

    if (!rest.userLicenses) {
        rest.userLicenses = 0
    }

    if (!rest.catalogLicenses) {
        rest.catalogLicenses = 0
    }

    return axios.post("/api/companies", {
        users: userIds,
        catalogs: catalogIds,
        ...rest
    })
}

export async function remove(id) {
    await axios.delete(`/api/companies/${id}`)
}

export function getOne(id) {
    return axios.get(`/api/companies/${id}`)
}
